import { useEffect, useState } from 'react';
import { debounce } from '@utils/lodash.utils';

export const useWindowDimensions = () => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);

    const debounceWindowResize = debounce(() => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    }, 300);

    window.addEventListener('resize', debounceWindowResize);

    return () => window.removeEventListener('resize', debounceWindowResize);
  }, []);

  return {
    windowWidth,
    windowHeight,
  };
};
